import { Component, inject, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacButtonComponent,
  CacDialogLayoutComponent,
  CacFieldComponent,
  CacSwitchComponent,
  ObjectHelper,
} from '@controladad/ng-base';
import { UserEntity } from '@models';
import { UserApiService } from '../../../services';
import { RoleItems, Roles, StatusValues } from '../../../data';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { AuthStore } from '../../../states';

export interface AdminUserDialogData {
  user?: UserEntity;
}

export type AdminUserDialogResult = boolean;

@Component({
  selector: 'lib-user-dialog',
  standalone: true,
  imports: [CacDialogLayoutComponent, CacFieldComponent, CacButtonComponent, CacSwitchComponent, NgIf],
  templateUrl: './admin-user-dialog.component.html',
  styleUrl: './admin-user-dialog.component.scss',
})
export class AdminUserDialogComponent
  extends CacBaseDialogComponent<AdminUserDialogData, AdminUserDialogResult>
  implements OnInit
{
  private userApi = inject(UserApiService);
  readonly isRestrictedAdmin = inject(AuthStore).isRestrictedAdmin();

  form = formGroup({
    fullName: formControl<string>(undefined, [Validators.required, Validators.maxLength(257)]),
    // role: formControl<number>(undefined, Validators.required),
    username: formControl<string>(undefined, Validators.required),
    password: formControl<string>(undefined),
    passwordConfirm: formControl<string>(undefined),
    status: formControl<number>(0), //Disabled
    email: formControl<string>(undefined, [Validators.required, Validators.email]),
    isRestrictedAdmin: formControl<boolean>(false),
  });

  StatusValues = StatusValues;
  RoleValues = RoleItems;

  ngOnInit() {
    if (this.data.user) {
      this.form.controls.password.setValidators([Validators.password()]);
      this.form.controls.passwordConfirm.setValidators([Validators.match(this.form.controls.password)]);
      this.userApi.getAdminDetails(this.data.user.id).subscribe((r) => {
        console.log(r);
        this.form.patchValue({ ...r.adminDetailsDTO });
      });
    } else {
      this.form.controls.password.setValidators([Validators.required, Validators.password()]);
      this.form.controls.passwordConfirm.setValidators([
        Validators.required,
        Validators.match(this.form.controls.password),
      ]);
    }
    this.form.controls.passwordConfirm.updateValueAndValidity();
    this.form.controls.password.updateValueAndValidity();
  }

  onSubmit(e: ButtonClickEvent) {
    const values = ObjectHelper.omit(this.form.getRawValue(), 'passwordConfirm');

    if (this.data.user) {
      // Only include password if it has a value
      const updateValues: any = { ...values, id: this.data.user.id, role: Roles.admin };
      if (!values.password) {
        updateValues.password = undefined;
      }

      this.userApi.updateAdmin(updateValues)
        .pipe(e.pipe())
        .subscribe(() => {
          this.submit(true);
        });
    } else {
      this.userApi.createAdmin({ ...values, role: Roles.admin })
        .pipe(e.pipe())
        .subscribe(() => {
          this.submit(true);
        });
    }
  }

  onDelete(e: ButtonClickEvent) {
    const id = this.data.user?.id;
    if (!id) return;
    this.userApi
      .delete({
        userIds: id,
        role: Roles.admin,
      })
      .pipe(e.pipe())
      .subscribe(() => {
        this.submit(true);
        snackbar$.show('Delete Successful');
      });
  }

  onForceLogout(e: ButtonClickEvent) {
    // TODO: UPDATE
    if (this.data.user)
      this.userApi
        .forceLogout(this.data.user.id, Roles.admin)
        .pipe(e.pipe())
        .subscribe(() => {
          this.dialog.close();
          snackbar$.show('Force Login Successful');
        });
  }
}
